import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('slack');
const type = createActionType('slack');

export const GET_SLACK_AUTHORIZATION = apiType('GetSlackAuthorization');
export const GET_SLACK_AUTHORIZATION_URL = apiType('GetSlackAuthorizationURL');
export const UNINSTALL_SLACK = apiType('UninstallSlack');
export const LIST_SLACK_CHANNELS = apiType('ListSlackChannels');
export const CREATE_SLACK_CHANNEL = apiType('CreateSlackChannel');
export const CREATE_EVENT_SUBSCRIPTION = apiType('CreateEventSubscription');
export const DELETE_EVENT_SUBSCRIPTION = apiType('DeleteEventSubscription');
export const GET_EVENT_SUBSCRIPTION = apiType('GetEventSubscription');
export const UPDATE_EVENT_SUBSCRIPTION_DELIVERY_TARGET = apiType(
    'UpdateEventSubscriptionDeliveryTarget'
);
export const UPDATE_CHANNEL = type('UpdateChannel');
